import { render } from "./home.vue?vue&type=template&id=957c9522&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=957c9522&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957c9522"],['__file',"src/components/home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "957c9522"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('957c9522', __exports__)) {
    api.reload('957c9522', __exports__)
  }
  
  module.hot.accept("./home.vue?vue&type=template&id=957c9522&scoped=true", () => {
    api.rerender('957c9522', render)
  })

}


export default __exports__